// extracted by mini-css-extract-plugin
export default {"wrapper":"App_wrapper__5XpU9","dynamicPage":"App_dynamicPage__BXjIx"};